import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TekstResourcePipe } from '../../pipes/tekstresource.pipe';
import { AutofocusService } from '../../services/autofocus/autofocus.service';

@Component({
  selector: 'bom-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.scss'],
})
export class WorkspaceComponent implements OnInit, OnChanges, AfterViewInit {
  @Input()
  titleKey: string;

  @Input()
  title: string;

  @Input()
  descriptionKey: string;

  @Input()
  description: string;

  @Input()
  isMandatory: boolean;

  @Input()
  autoScrollTop = true;

  @Input()
  isAnySagForaeldet: boolean;

  @Input()
  laasBegrundelse?: string;

  @Output()
  openCopyModalEvent = new EventEmitter();

  @ViewChild('heading')
  heading: ElementRef<HTMLElement>;

  constructor(
    private tekstResourcePipe: TekstResourcePipe,
    private autofocusService: AutofocusService
  ) {}

  ngOnInit(): void {
    this.autofocusService.clear();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.titleKey) {
      if (this.titleKey) {
        this.title = this.tekstResourcePipe.transform(this.titleKey);
      } else {
        this.title = '';
      }
    }

    if (changes.descriptionKey) {
      if (this.descriptionKey) {
        this.description = this.tekstResourcePipe.transform(this.descriptionKey);
      } else {
        this.description = '';
      }
    }
  }

  ngAfterViewInit() {
    // If autoScrollTop is enabled, heading is shown, no element to scroll to defined
    // in hash, heading is outside viewport, scroll to heading
    if (this.autoScrollTop && this.heading && this.heading.nativeElement && !location.hash) {
      // setTimeout is needed to allow view to be rendered before scrolling.
      setTimeout(() => {
        const el = this.heading.nativeElement;
        const rect = el.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
          el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }
  }

  openCopyModal() {
    this.openCopyModalEvent.emit('true');
  }
}
